var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 20.52,
    height: 16.27,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 20.52,
    height: 16.27,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.12,
    y: 5.98,
    width: 18.9,
    height: 13.58,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 5.98,
    width: 0.31,
    height: 12.96,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.36,
    y: 13.93,
    width: 3.77,
    height: 3.4,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 13.93,
    width: 3.63,
    height: 3.4,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4875"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2131",
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4866"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9038",
    d: "M13.38,5.98H2v14.29H22.52V5.98H13.38Z",
    style: {
      fill: "#117884"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4821"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9039",
    d: "M21.4,18.95c-2.94-1.13-6.2-1.13-9.14,0V5.98c2.94-1.14,6.2-1.14,9.14,0v12.96",
    style: {
      fill: "#e7f5f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9040",
    d: "M20.07,7.02s-.03,0-.05,0c-2.09-.55-4.29-.55-6.38,0-.1,.03-.2-.03-.23-.13-.03-.1,.03-.2,.13-.23h0c2.15-.57,4.42-.57,6.57,0,.1,.02,.16,.12,.14,.22-.02,.09-.1,.15-.19,.14",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9041",
    d: "M20.07,8.51s-.03,0-.05,0c-2.09-.55-4.29-.55-6.38,0-.1,.03-.2-.03-.23-.13s.03-.2,.13-.23c2.15-.57,4.42-.57,6.57,0,.1,.02,.16,.12,.14,.22-.02,.09-.1,.15-.19,.14",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9042",
    d: "M20.07,9.99s-.03,0-.05,0c-2.09-.55-4.29-.55-6.38,0-.1,.03-.2-.03-.23-.13s.03-.2,.13-.23h0c2.15-.57,4.42-.57,6.57,0,.1,.02,.16,.12,.14,.22-.02,.09-.1,.15-.19,.14",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9043",
    d: "M20.07,11.47s-.03,0-.05,0c-2.09-.55-4.29-.55-6.38,0-.1,.03-.2-.03-.23-.13s.03-.2,.13-.23c2.15-.57,4.42-.57,6.57,0,.1,.02,.16,.12,.14,.22-.02,.09-.1,.15-.19,.14",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9044",
    d: "M13.59,12.96c-.1,0-.19-.08-.19-.18,0-.09,.06-.17,.14-.19,2.15-.57,4.42-.57,6.57,0,.1,.03,.16,.13,.13,.23-.03,.1-.13,.16-.23,.13h0c-2.09-.55-4.29-.55-6.38,0-.02,0-.03,0-.05,0",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9045",
    d: "M13.59,14.45c-.1,0-.19-.08-.19-.18,0-.09,.06-.17,.14-.19,2.15-.57,4.42-.57,6.57,0,.1,.03,.16,.13,.13,.23-.03,.1-.13,.16-.23,.13h0c-2.09-.55-4.29-.55-6.38,0-.02,0-.03,0-.05,0",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9046",
    d: "M20.07,15.93s-.03,0-.05,0c-2.09-.55-4.29-.55-6.38,0-.1,.03-.2-.03-.23-.13s.03-.2,.13-.23c2.15-.57,4.42-.57,6.57,0,.1,.02,.16,.12,.14,.22-.02,.09-.1,.15-.19,.14",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9047",
    d: "M13.59,17.42c-.1,0-.19-.08-.19-.18,0-.09,.06-.17,.14-.19,2.15-.57,4.42-.57,6.57,0,.1,.03,.16,.13,.13,.23-.03,.1-.13,.16-.23,.13-2.09-.55-4.29-.55-6.38,0-.02,0-.03,0-.05,0",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9048",
    d: "M12.26,18.95c-2.94-1.13-6.2-1.13-9.14,0V5.98c2.94-1.14,6.2-1.14,9.14,0v12.96",
    style: {
      fill: "#e7f5f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9049",
    d: "M10.93,7.02s-.03,0-.05,0c-2.09-.55-4.29-.55-6.38,0-.1,.03-.2-.03-.23-.13-.03-.1,.03-.2,.13-.23h0c2.15-.57,4.42-.57,6.57,0,.1,.02,.16,.12,.14,.22-.02,.09-.1,.15-.19,.14",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9050",
    d: "M4.45,8.51c-.1,0-.19-.08-.19-.18,0-.09,.06-.17,.14-.19,2.15-.57,4.42-.57,6.57,0,.1,.03,.16,.13,.13,.23-.03,.1-.13,.16-.23,.13-2.09-.55-4.29-.55-6.38,0-.02,0-.03,0-.05,0",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9051",
    d: "M10.93,9.99s-.03,0-.05,0c-2.09-.55-4.29-.55-6.38,0-.1,.03-.2-.03-.23-.13-.03-.1,.03-.2,.13-.23,2.15-.57,4.42-.57,6.57,0,.1,.02,.16,.12,.14,.22-.02,.09-.1,.15-.19,.14",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9052",
    d: "M4.45,11.47c-.1,.01-.2-.06-.21-.16-.01-.1,.06-.2,.16-.21h0c2.15-.57,4.42-.57,6.57,0,.1,.03,.16,.13,.13,.23-.03,.1-.13,.16-.23,.13-2.09-.55-4.29-.55-6.38,0-.02,0-.03,0-.05,0",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9053",
    d: "M10.93,12.96s-.03,0-.05,0c-2.09-.55-4.29-.55-6.38,0-.1,.03-.2-.03-.23-.13s.03-.2,.13-.23c2.15-.57,4.42-.57,6.57,0,.1,.02,.16,.12,.14,.22-.02,.09-.1,.15-.19,.14",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9054",
    d: "M4.45,14.45c-.1,0-.19-.08-.19-.18,0-.09,.06-.17,.14-.19,2.15-.57,4.42-.57,6.57,0,.1,.03,.16,.13,.13,.23-.03,.1-.13,.16-.23,.13-2.09-.55-4.29-.55-6.38,0-.02,0-.03,0-.05,0",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9055",
    d: "M4.45,15.93c-.1,0-.19-.08-.19-.18,0-.09,.06-.17,.14-.19,2.15-.57,4.42-.57,6.57,0,.1,.03,.16,.13,.13,.23-.03,.1-.13,.16-.23,.13-2.09-.55-4.29-.55-6.38,0-.02,0-.03,0-.05,0",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9056",
    d: "M4.45,17.42c-.1,0-.18-.09-.17-.2,0-.08,.05-.14,.13-.17,2.15-.57,4.42-.57,6.57,0,.1,.03,.16,.13,.13,.23-.03,.1-.13,.16-.23,.13-2.09-.55-4.29-.55-6.38,0-.02,0-.03,0-.05,0",
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9057",
    d: "M3.12,18.94H12.26c-2.94-1.13-6.2-1.13-9.14,0",
    style: {
      fill: "#96d1db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9058",
    d: "M12.26,18.94h9.14c-2.94-1.13-6.2-1.13-9.14,0",
    style: {
      fill: "#96d1db"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4810",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4809"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9059",
    d: "M21.4,5.98c0,4.32,0,8.64,0,12.96H3.12l.62,.62H22.02V6.6l-.62-.62Z",
    style: {
      fill: "#040506"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4813",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4812"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9060",
    d: "M12.26,18.94s-.01-.2-.03-.56-.04-.86-.06-1.47-.04-1.32-.05-2.08-.01-1.57-.02-2.38,0-1.62,.02-2.38,.04-1.47,.05-2.08,.04-1.11,.06-1.47l.03-.56,.03,.56c.01,.35,.04,.86,.06,1.47s.04,1.32,.05,2.08,.01,1.57,.02,2.38,0,1.62-.02,2.38-.04,1.47-.05,2.08-.04,1.11-.06,1.47-.03,.56-.03,.56",
    style: {
      fill: "#040506"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9061",
    d: "M6.97,15.24c-.15-.19-.11-.47,.09-.61s.47-.11,.61,.09,.11,.47-.09,.61c-.13,.1-.31,.12-.45,.04,0,0,0,0-.01-.01l-1.62,1.97,2.01-.72,1.62-1.9-1.76-1.5-1.62,1.9-.39,2.09,1.61-1.96Z",
    style: {
      fill: "#9e9d9d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4818"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4816",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4815"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9062",
    d: "M7.72,15.16c-.1,.22-.37,.32-.59,.21,0,0,0,0,0,0,0,0,0,0-.01-.01l-1.62,1.97,2.01-.72,1.62-1.9-.92-.78-.6,.71c.15,.13,.2,.34,.11,.52",
    style: {
      fill: "#dca"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9063",
    d: "M5.4,17.15l-.04,.04,.04-.04Z",
    style: {
      fill: "#bba77d"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9064",
    d: "M13.98,5.24c.42-.48,1.15-.52,1.63-.09,.46,.41,.52,1.11,.13,1.59l-6.62,7.97c-.41,.49-.71,.04-1.2-.38s-.97-.64-.56-1.12l6.62-7.97Z",
    style: {
      fill: "#e34142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9065",
    d: "M11.62,11.73l.81-.98-1.71-1.55-.87,1.05,1.76,1.49Z",
    style: {
      fill: "#c73241"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9066",
    d: "M12.02,11.77l4.31-5.22c.52-.62,.43-1.54-.19-2.05-.61-.51-1.51-.44-2.03,.16l-4.4,5.09,2.3,2.02Z",
    style: {
      fill: "#e34142"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9067",
    d: "M7.93,14.33c.49,.41,.78,.86,1.2,.38l2.63-3.17,.26,.23,4.31-5.22c.37-.43,.45-1.02,.22-1.54l-.38-.52L7.89,14.3l.04,.03",
    style: {
      fill: "#c73241"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9068",
    d: "M10.29,8.42l2.64-3.02,2.55,2.17,.58-.69-2.55-2.17,.04-.05c.14-.17,.12-.42-.04-.57-.17-.14-.42-.12-.57,.04l-3.26,3.76c-.14,.17-.12,.42,.05,.57,.17,.14,.42,.12,.57-.05h0",
    style: {
      fill: "#453645"
    }
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.8093bd96868ca6c01a74b881e7faf6b1.svg";
export { ForwardRef as ReactComponent };